import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 27 — Tour de Promociones (motor + UX).
 *
 * Cubre los 4 tipos, semántica aditivo vs sustractivo para REGALO,
 * cantidad mínima vs monto mínimo, vigencia, días de la semana, prioridad
 * y acumulables.
 */
export const tourPromociones: TourDefinition = {
  id: 'promociones',
  title: 'Cómo armar Promociones',
  steps: [
    {
      element: '[data-tour="prom-header"]',
      popover: {
        title: '1. Promociones del negocio',
        description:
          'Configura descuentos, regalos y precios especiales que se aplican AUTOMÁTICAMENTE al confirmar el pedido. El cliente no tiene que pedirlas — el sistema las detecta.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="prom-nueva"]',
      popover: {
        title: '2. Crear promoción — los 4 tipos',
        description:
          'Tipos: 💰 % de descuento · 💵 Monto fijo · 🏷 Precio fijo (ej. "Pan 2x$15") · 🎁 Regalo (un producto extra). Cada tipo abre campos distintos según lo que necesita.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prom-nueva"]',
      popover: {
        title: '3. Regalo: aditivo o sustractivo',
        description:
          'En tipo REGALO marca el toggle "El regalo descuenta su precio del total". 🎁 SIN marcar = CORTESÍA (cliente paga subtotal completo + se lleva el regalo gratis, lo absorbe el negocio). 🏷 Marcado = CUPÓN (el valor se descuenta del total, como rebaja disfrazada).',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prom-nueva"]',
      popover: {
        title: '4. Cantidad mínima vs Monto mínimo',
        description:
          'Cantidad mín. = "se necesitan N unidades elegibles para gatillar" (ej. Pan Ajo 2x$15 requiere mín. 2). Monto mín. = "subtotal del pedido debe ser ≥ $X" (ej. Frijoles GRATIS con compra de $300).',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prom-nueva"]',
      popover: {
        title: '5. Vigencia + días de la semana',
        description:
          'Vigencia = rango de fechas activo. Días = filtra solo ciertos días ("Sólo viernes", "Sólo sábado y domingo"). La promo se desactiva sola fuera de horario; no requiere acción manual.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prom-nueva"]',
      popover: {
        title: '6. Elegibles + acumulable',
        description:
          'Selecciona QUÉ productos y/o paquetes disparan la promo (atajos "Todos · Limpiar"). Acumulable = puede combinarse con otras promos vigentes simultáneas (sino la mayor descuento gana sola).',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prom-filtros"]',
      popover: {
        title: '7. Estados visuales reales',
        description:
          'Los chips clasifican por estado AHORA: 🟢 Activas (vigentes Y aplica hoy) · 📅 Programadas (vigencia futura) · ⏸ Pausadas (apagadas manualmente) · 🔴 Vencidas. Considera vigencia + día de la semana real.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="prom-cards"]',
      popover: {
        title: '8. Cards con lenguaje natural',
        description:
          'Cada promo se describe como "20% de descuento en Lomo, sólo martes" en lugar de jerga técnica. El botón ⏸ Pausar/Reanudar la activa/desactiva sin abrir formulario.',
        side: 'top',
      },
    },
  ],
};
